import { Marker, Popup } from 'react-map-gl'
import styled from 'styled-components'

const StyledMarker = styled(Marker)`
  z-index: ${(props) => (props.selected ? 3 : 0)};
`

const StyledPopup = styled(Popup)`
  z-index: 2;

  .mapboxgl-popup-content {
    padding: 0;
    width: 320px;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14),
      0px 1px 14px 0px rgba(0, 0, 0, 0.12);
  }
`

export { StyledMarker, StyledPopup }
